/* eslint-disable no-secrets/no-secrets */
import { defineMessages } from 'react-intl';

export default defineMessages({
    numberTypeHeader: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.DinghyMotor.#',
        defaultMessage: '#'
    },
    yearTypeHeader: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.DinghyMotor.Year',
        defaultMessage: 'Year'
    },
    brandTypeHeader: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.DinghyMotor.Brand',
        defaultMessage: 'Brand'
    },
    hpTypeHeader: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.DinghyMotor.HP',
        defaultMessage: 'HP'
    },
    serialNumberTypeHeader: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.DinghyMotor.Serial Number',
        defaultMessage: 'Serial Number'
    },
    valueTypeHeader: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.DinghyMotor.Value ($)',
        defaultMessage: 'Value ($)'
    },
    addDinghyMotor: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.DinghyMotor.Add Dinghy Motor',
        defaultMessage: 'Add Dinghy Motor'
    },
    add: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.DinghyMotor.AddButton',
        defaultMessage: 'Add'
    },
    removeDinghyMotor: {
        id: 'quoteandbind.PRMRecMarLinedirectives.templates.DinghyMotor.Remove Dinghy Motor',
        defaultMessage: 'Removed Dinghy Motor {brandDesc}'
    }
});